import { render, staticRenderFns } from "./EventDetailMessages.vue?vue&type=template&id=67e2d5d5&"
import script from "./EventDetailMessages.vue?vue&type=script&lang=ts&"
export * from "./EventDetailMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports